import { Box, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { Trans } from "react-i18next"; // Assicurati di importare Trans se stai usando i18n
import logo from "../../../assets/logoblu.jpeg";

const CustomTypography = ({ text, children = null, addLogo = false }) => {
  return (
    <Stack
      sx={{
        width: "100%",
        display: "flex",
        p: 8,
        flexDirection: "row",
        alignItems: "stretch", // Assicura che i figli abbiano la stessa altezza
        justifyContent: "center",
        height: "100%",
      }}
    >
      <Box
        sx={{
          borderLeft: "1px solid black",
          borderTop: "1px solid black",
          borderBottom: "1px solid black",
          width: "8%",
          height: "auto", // Si adatta all'altezza del contenitore padre
        }}
      />
      {children ? (
        children
      ) : (
        <Stack
          spacing={4}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            padding: "5px 35px 0px 35px",
            maxWidth: "700px",
          }}
        >
          <img
            src={logo}
            alt="logo"
            style={{
              width: "80px",
              height: "80px",
              display: addLogo ? "block" : "none",
            }}
          />
          <Typography
            fontSize={"18px"}
            textAlign="center"
            letterSpacing="1.4px"
            lineHeight={1.6}
            sx={{
              fontFamily: "ivymode",
              fontWeight: "300",
              color: "#3c3c3c",
            }}
          >
            <Trans
              i18nKey={text}
              components={{
                bold: (
                  <b
                    style={{
                      fontWeight: "600",
                    }}
                  />
                ),
                italic: <i />,
              }}
            />
          </Typography>
        </Stack>
      )}

      <Box
        sx={{
          borderRight: "1px solid black",
          borderTop: "1px solid black",
          borderBottom: "1px solid black",
          width: "8%",
          height: "auto", // Si adatta all'altezza del contenitore padre
        }}
      />
    </Stack>
  );
};

export default CustomTypography;
